<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="atena/tela-grupo"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi"
          id="identificadortelagrupo" >
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaotelagrupo }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" @change="$refs.buscaSimpleApi.busca = ''"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadortelagrupo"
      :novo="novo"
      :editar="editar"
      :excluir="excluir"
      :cancelar="cancelar"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabela" hover>
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <Input type="text" label="Código Grupo de Telas" v-model="form.identificadortelagrupo" disabled />
          <Input type="text" label="Descrição Grupo de Telas" ref="focusCampo" v-model="form.descricaotelagrupo" :disabled="acao == ''" :v="$v.form.descricaotelagrupo" />
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { required, maxLength } from 'vuelidate/lib/validators';

const AtenaTelaGrupoRepository = RepositoryFactory.get('atenaTelaGrupo');

const setFormInicial = () => ({
  descricaotelagrupo: '',
});

export default {
  name: 'TelaGrupo',
  components: {
    BuscaSimplesApi,
  },
  data() {
    return {
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaotelagrupo',
      buscaOptions: [
        { value: 'descricaotelagrupo', text: 'Descrição' },
      ],
      formUltimo: {},
      acao: '',
    };
  },
  validations: {
    form : {
      descricaotelagrupo: { required, maxLength: maxLength(60) },
    },
    /*   GAMBIARRA
           A regra de validação abaixo foi inserida apenas para corrigir um pequeno erro na interface de usuário que ocorre quando o botão cancelar é usado.

           Quando a última regra de validação declarada não é válida, a validação impede que o botão cancelar seja executado.
           Porém, quando a última regra é válida, o erro não ocorre.
           Nesse caso, como nesta tela só há um campo sendo validado e ele não está válido quando o botão cancelar é clicado,
           é necessário lançar uma regra vazia abaixo somente para evitar de o erro ocorrer.
    */
    submitText: {}
  },
  methods: {
    tabela() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Grupo de Telas',
          rota_api: 'atena/tela-grupo/tabela',
          headers: [
            { text: 'Identificador', value: 'identificadortelagrupo', sortable: false },
            { text: 'Descrição', value: 'descricaotelagrupo', sortable: false },
          ],
        },
      });
    },
    novo() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editar() {
      this.acao = 'editar';
    },
    cancelar() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluir() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este grupo de telas?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await AtenaTelaGrupoRepository.deleteTelaGrupo(this.form.identificadortelagrupo);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        const funcao = (this.acao === 'novo') ? 'post' : 'put';
        const { data } = await AtenaTelaGrupoRepository[`${funcao}TelaGrupo`](this.form);

        this.acao = '';
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...data.results };
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.$v.$reset();
      }
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = { ...dados.results };
      this.formUltimo = { ...this.form };
    },
  },
}
</script>

<style>

</style>
